import {newsContentManager} from '../../../api/newsContentManager';

import EventItem from '../../../api/eventItemEntity';
import { notifyBreadcrumChangeAction } from '../../../common/components/breadcrumb/actions/notifyBreadcrumChange';
import { actionTypes } from '../../../common/constants/actionTypes';

export const fetchEventItemByIdAction = (id: string) => (dispatch: any) => {

  newsContentManager.fetchEventItemByIdAsync("/" + id)
    .then((newsItem) => {
      dispatch(fetchEventItemByIdAsyncCompleted(newsItem));
      dispatch(notifyBreadcrumChangeAction(actionTypes.BREADCRUMB_CHANGED_ON_NEWS_PAGE, newsItem.title));
    });
};

const fetchEventItemByIdAsyncCompleted = (eventItem: EventItem) => ({
  payload: eventItem,
  type: actionTypes.FETCH_EVENT_ITEM_BY_ID_COMPLETED
});


// WEBPACK FOOTER //
// ./src/components/eventPage/actions/fetchEventItemById.ts